module.exports = __webpack_public_path__ + "img/aboutcer.fd29e154.png";